/* COPYRIGHT Esri - https://js.arcgis.com/5.1.20/LICENSE.txt */
const i={Dirty:1,Overridden:2,Computing:4,NonNullable:8,HasDefaultValue:16,DepTrackingInitialized:32,AutoTracked:64,ExplicitlyTracking:128};export{i as Flags};
